import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { loadConsentMessage, postGrantConsent } from "actions/loginActions";
import { Button } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import GlobalMessageBoard from "../common/global-message-board";
class GrantConsentPage extends React.Component {
  componentDidMount() {
    this.props.loadConsentMessage();
  }

  render() {
    const { consentMessage, postGrantConsent, intl } = this.props;

    return (
      <div>
        <GlobalMessageBoard />
        <div className="consent-wrapper">
          <div className="consent">
            <div className="o-wrapper">
              <article className="consent__card">
                <section>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: consentMessage,
                        defaultMessage: consentMessage,
                      }),
                    }}
                  />
                </section>
              </article>
              <p className='button-container-pp'>
                <Button primary className="consent__button" onClick={postGrantConsent}>
                  {intl.formatMessage(messages.consentTextDescription)}
                </Button>
                <Button to="/logout" secondary className="consent__button">
                  {intl.formatMessage(messages.logoutTextDescription)}
                </Button>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GrantConsentPage.propTypes = {
  loadConsentMessage: PropTypes.func,
  consentMessage: PropTypes.string,
  postGrantConsent: PropTypes.func,
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ login: { consentMessage } }) => ({ consentMessage });
const mapDispatchToProps = {
  loadConsentMessage,
  postGrantConsent,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GrantConsentPage)
);



// WEBPACK FOOTER //
// ./components/consent/GrantConsentPage.js